module.exports = __webpack_public_path__ + "img/user-nav-bg.6ccddaf1.jpg";